import { render, staticRenderFns } from "./ImportsChargeCodeMappings.vue?vue&type=template&id=88945952"
import script from "./ImportsChargeCodeMappings.vue?vue&type=script&lang=js"
export * from "./ImportsChargeCodeMappings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports